import { mutations } from './mutations';
import { actions } from './actions';
export var state = {
    branding: null,
    privacyPolicy: null,
};
export var companySettings = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
};
